import React, { useEffect, useState } from "react";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import {
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
  DropdownItem,
} from "reactstrap";
import Cookies from 'js-cookie'
import {
  Block,
  BlockHead,
  BlockBetween,
  BlockHeadContent,
  BlockTitle,
  Icon,
  Button,
  PaginationComponent,
  DataTable,
  DataTableBody,
  DataTableHead,
  DataTableRow,
  DataTableItem,
} from "../../components/Component";
import FormModal from "./FormModal";
import { handleDeleteApis, handleGetApis } from "../../service/Api";

export const OfferBar = () => {
  useEffect(() => {
    fetchCategory();
}, []);
  const [tDealData, setTDealData] = useState('')
  const fetchCategory = () => {
    try{
const res = handleGetApis('admin/get/offerbar')
    res.then(function (result) {
        console.log(result)
      if (result) {
        setTDealData(result.data.result)
      }
    })
    } catch(err){
        console.log(err)
    }
      
  }
  
  const [sm, updateSm] = useState(false);
  const [modal, setModal] = useState({
    edit: false,
    add: false,
  });
  const [data, setData] = useState([]);
  useEffect(() => {
    if (tDealData) {
      setData([...tDealData]);
    }
  }, [tDealData])
  
  const [formData, setFormData] = useState({
    title: "",
    is_active: true
  });
  const [editFormData, setEditFormData] = useState({
    title: "",
    is_active: true
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage] = useState(7);

  // function to reset the form
  const resetForm = () => {
    setFormData({
        title: "",
        is_active : true
    });
  };

  const closeModal = () => {
    setModal({ add: false })
    resetForm();
  };

  const closeEditModal = () => {
    setModal({ edit: false })
    resetForm();
  };
  // function that loads the want to editted data
  const onEditClick = (id) => {
    if (tDealData && tDealData) {
      tDealData.forEach((item) => {
        if (item.id === id) {
          setEditFormData({
            id: item.id,
              title: item.title,
            is_active : item.is_active
          });
          setModal({ edit: true }, { add: false });
        }
      });
    }
  };  



  // Get current list, pagination
  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const currentItems = tDealData && tDealData.slice(indexOfFirstItem, indexOfLastItem);
  // Change Page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  // Delete TravelDeals
  const deleteTravelDeals = (id) => {
    const res = handleDeleteApis(`admin/delete/offerbar`, {id})
    res.then(function (result) {
      if (result) {
        alert(result.data.message)
        setTDealData((prevData) => prevData.filter((item) => item.id !== id));
      }
    })
  }
  const handleDelete = (id) => {
    if (window.confirm("are you sure want to delete offer title")) {
      deleteTravelDeals(id);
    }
  }
  console.log(tDealData,'tDealData');
  
  return <>
    <Head title="Offer Bar Title"></Head>
    <Content>
      <BlockHead size="sm">
        <BlockBetween>
          <BlockHeadContent>
            <BlockTitle page>Offer Bar Title</BlockTitle>
          </BlockHeadContent>
          <BlockHeadContent>
            <div className="toggle-wrap nk-block-tools-toggle">
              <Button
                className={`btn-icon btn-trigger toggle-expand me-n1 ${sm ? "active" : ""}`}
                onClick={() => updateSm(!sm)}
              >
                <Icon name="menu-alt-r"></Icon>
              </Button>
              <div className="toggle-expand-content" style={{ display: sm ? "block" : "none" }}>
                <ul className="nk-block-tools g-3">
                 
                  <li className="nk-block-tools-opt" onClick={() => setModal({ add: true })}>
                    <Button color="primary">
                      <Icon name="plus"></Icon>
                      <span>Add Offer Bar Title</span>
                    </Button>
                  </li>
                </ul>
              </div>
            </div>
          </BlockHeadContent>
        </BlockBetween>
      </BlockHead>
      <Block>
        <DataTable className="card-stretch">
          <DataTableBody>
            <DataTableHead className="nk-tb-item nk-tb-head">
              <DataTableRow>
                <span className="sub-text">Title</span>
              </DataTableRow>
              <DataTableRow size='sm'>
                <span className="sub-text">Status</span>
              </DataTableRow>
              <DataTableRow className="nk-tb-col-tools text-end">
                <span className="sub-text">Action</span>
              </DataTableRow>
            </DataTableHead>
            {currentItems?.length > 0
              ? currentItems.map((item) => {
                return (
                  <DataTableItem key={item.id}>
                    <DataTableRow>
                      <li style={{listStyle : "none"}}>{item.title}</li>
                    </DataTableRow>
                    <DataTableRow size='sm'>
                      <li style={{listStyle : "none",color : item.is_active === 1 ? "green" : "red"}}>{item.is_active === 1 ? 'Active' : "Non Active"}</li>
                    </DataTableRow>
                      <DataTableRow className="nk-tb-col-tools text-end">
                        <ul className="nk-tb-actions gx-1">
                          <li>
                            <UncontrolledDropdown>
                              <DropdownToggle tag="a" className="text-soft dropdown-toggle btn btn-icon btn-trigger">
                                <Icon name="more-h"></Icon>
                              </DropdownToggle>
                              <DropdownMenu end>
                                <ul className="link-list-opt no-bdr">
                                  <li onClick={()=>{onEditClick(item.id)}}>
                                    <DropdownItem
                                      tag="a"
                                      href="#edit"
                                      onClick={(ev) => {
                                        ev.preventDefault();
                                      }}
                                    >
                                      <Icon name="edit"></Icon>
                                      <span>Edit</span>
                                    </DropdownItem>
                                  </li>
                                    <li onClick={()=>{handleDelete(item.id)}}>
                                      <DropdownItem
                                        tag="a"
                                        href="#markasdone"
                                        onClick={(ev) => {
                                          ev.preventDefault();
                                        }}
                                      >
                                        <Icon name="trash"></Icon>
                                        <span>Delete</span>
                                      </DropdownItem>
                                    </li>
                                </ul>
                              </DropdownMenu>
                            </UncontrolledDropdown>
                          </li>
                        </ul>
                      </DataTableRow>
                  </DataTableItem>
                  );
                })
              : null}
          </DataTableBody>
          <div className="card-inner">
            {data?.length > 0 ? (
              <PaginationComponent
                itemPerPage={itemPerPage}
                totalItems={data?.length}
                paginate={paginate}
                currentPage={currentPage}
              />
            ) : (
              <div className="text-center">
                <span className="text-silent">No data found</span>
              </div>
            )}
          </div>
        </DataTable>
      </Block>
      
      <FormModal modal={modal.add} modalType="add" formData={formData} setFormData={setFormData} closeModal={closeModal} fetchCategory={fetchCategory}/>
      <FormModal modal={modal.edit} modalType="edit" formData={editFormData} setFormData={setEditFormData} closeModal={closeEditModal} fetchCategory={fetchCategory}/>
    </Content>
  </>;
};

export default OfferBar;